// extracted by mini-css-extract-plugin
export default {"root":"DemoUserBanner_root__fG+4X"};